const parseJSON = (json, fallback) => {
	let parsed;
	try {
		parsed = JSON.parse(json);
	} catch (e) {
		parsed = fallback;
	}
	return parsed;
};

export default parseJSON;



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/parseJSON.js